import moment from "moment";

// Formatting of client billing plans, usage and invoices

export const money = (n, currency = "GBP") => {
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency,
      maximumFractionDigits: Number(n) % 1 ? 2 : 0,
    }).format(Number(n) || 0);
  } catch (e) {
    return `${currency} ${Number(n || 0).toFixed(2)}`;
  }
};

const clips = (n) => `${n} clip${n === 1 ? "" : "s"}`;

export const hasLimit = (plan) => ["monthly", "annual"].includes(plan?.type);

// "Monthly · 50 clips · £1,000/month"
export const planSummary = (plan) => {
  if (!plan) return "—";
  if (plan.type === "monthly")
    return `Monthly · ${clips(plan.clipLimit)} · ${money(plan.fee, plan.currency)}/month`;
  if (plan.type === "annual")
    return `Annual · ${clips(plan.clipLimit)} · ${money(plan.fee, plan.currency)}/year`;
  return plan.perClipPrice > 0 ? `Per clip · ${money(plan.perClipPrice, plan.currency)}` : "Per clip";
};

// When the current limit period ends: "resets Nov 1" / "plan year ends Sep 30, 2027"
export const periodEndLabel = (plan, usage) => {
  if (!usage?.period?.end) return "";
  const end = moment.utc(usage.period.end);
  return plan?.type === "annual"
    ? `plan year ends ${end.clone().subtract(1, "day").format("MMM D, YYYY")}`
    : `resets ${end.format("MMM D")}`;
};

// Short note for licensing a new clip under the plan
export const nextClipNote = (plan, usage) => {
  if (!hasLimit(plan) || !usage) return null;
  const period = plan.type === "annual" ? "this plan year" : "this month";
  if (usage.remaining > 0)
    return { over: false, text: `Included in your plan · ${usage.remaining} of ${plan.clipLimit} left ${period}` };
  return {
    over: true,
    text: `Over your plan limit · billed at ${money(plan.overagePrice, plan.currency)} per clip`,
  };
};

export const invoiceStatus = (inv) => {
  if (inv.status === "paid") return { label: `Paid ${moment(inv.paidAt).format("MMM D")}`, tone: "paid" };
  if (inv.status === "sent" && inv.dueAt && moment(inv.dueAt).isBefore(moment()))
    return { label: "Overdue", tone: "overdue" };
  if (inv.status === "sent")
    return { label: `Due ${moment(inv.dueAt).format("MMM D")}`, tone: "due" };
  return { label: inv.status === "void" ? "Void" : "Draft", tone: "draft" };
};

export const invoicePeriod = (inv) => {
  const start = moment.utc(inv.periodStart);
  const end = moment.utc(inv.periodEnd).subtract(1, "day");
  return inv.kind === "annual_fee"
    ? `${start.format("MMM D, YYYY")} – ${end.format("MMM D, YYYY")}`
    : start.format("MMMM YYYY");
};
